import React, { useState, useEffect } from "react";

import Breadcrumbs from "../../../components/Breadcrumbs";

import { useTranslation } from "react-i18next";

import Swal from "sweetalert2";

import AuthUser from "../../../components/AuthUser";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "../../../components/Spinner";
import CrewChangeFilter from "../Administration/employees/CrewChangeFilter";
import CrewChangeTable from "../Administration/employees/CrewChangeTable";
import CrewChangeModal from "../../../components/Administration/employees/CrewChangeModal";

const CrewChanges = () => {
  // eslint-disable-next-line no-unused-vars

  const { http, url_root, user_permissoes, verificarPermissao, getMissao } =
    AuthUser();

  const [crew_changes, setcrew_changes] = useState([]);

  const [filteredcrew_changes, setFilteredcrew_changes] = useState([]);

  const [colaboradores, setColaboradores] = useState([]);
  const [projetos, setProjetos] = useState([]);

  const { t } = useTranslation();

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const handleSubmissionSuccess = (crew_changes) => {
    // Refresh acessos state or trigger any necessary actions
    setcrew_changes(crew_changes);
  };

  // Callback function to receive filtered users from UserFilter
  const handleFilterSubmit = (filteredcrew_changes) => {
    setFilteredcrew_changes(filteredcrew_changes);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Chama a função assíncrona getUtilizador()
        await getColaboradores();
        await getProjetos();
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };
    // Chama a função fetchData() para iniciar o processo
    fetchData();
  }, []);

  const getProjetos = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/listar-postos-ativos/" + getMissao()?.id);

      setProjetos(res?.data?.postos);

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  const getColaboradores = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/utilizadores/ativados/" + getMissao()?.id);

      setColaboradores(res.data.utilizadores);

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  if (verificarPermissao("CARGO", "ver"))
    if (loading)
      return (
        <>
          <Spinner></Spinner>
        </>
      );
    else
      return (
        <>
          (
          <>
            <div className="page-wrapper">
              <div className="content container-fluid">
                <Breadcrumbs
                  maintitle={t("Crew Changes")}
                  title="Dashboard"
                  subtitle={t("Entradas e saidas")}
                  modal="#add_crew_change_modal"
                  name={t("Add Crew Change")}
                />

                <CrewChangeFilter
                  onFilterSubmit={handleFilterSubmit}
                  projetos={projetos}
                />

                <CrewChangeTable
                  crew_changes={
                    filteredcrew_changes.length > 0
                      ? filteredcrew_changes
                      : crew_changes
                  }
                  colaboradores={colaboradores}
                />

                <CrewChangeModal
                  onSubmissionSuccess={handleSubmissionSuccess}
                  colaboradores={colaboradores}
                />
              </div>
            </div>{" "}
          </>
          );{" "}
        </>
      );
  else
    return (
      <>
        <div className="page-wrapper cardhead">
          <div className="content ">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">SEM PERMISSÃO</h3>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">
                      <i className="fa fa-times-circle text-danger"></i>&nbsp;
                      OPERAÇÃO NÃO AUTORIZADA
                    </h4>
                  </div>
                  <div className="card-body">
                    <p>
                      Esta operação não é autorizada para o seu nivel de acesso
                      ao sistema, por favor contacte o administrador do sistema.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default CrewChanges;
